import lazyLoadView from '@router/lazy-loader'
import ContainerView from './views/main'
import configs from './config'

const routePrefix = configs.routePrefix

const moduleName = configs.name

const routeNamePrefix = configs.routeNamePrefix

export default [
  {
    path: `${routePrefix}`,
    component: ContainerView,
    meta: {
      moduleName,
      breadcrumbKey(route, translator, pluralTranslator) {
        if (
          route.query.moduleName &&
          ['project'].indexOf(route.query.moduleName) >= 0
        ) {
          return `${translator(route.query.moduleName)} ${translator(
            'management'
          )}`
        }
        return `${pluralTranslator('user')}`
      },
      nonLinked: true,
    },
    children: [
      {
        path: '',
        name: routeNamePrefix,
        component: () =>
          lazyLoadView(import(/* webpackChunkName: "users" */ './views/list')),
        meta: {
          breadcrumbKey(route, translator, pluralTranslator) {
            if (
              route.query.moduleName &&
              ['project'].indexOf(route.query.moduleName) >= 0
            ) {
              return `${translator(route.query.moduleName)} ${pluralTranslator(
                'role'
              )}`
            }
            return `${pluralTranslator('role')}`
          },
        },
      },
      {
        path: 'create',
        name: `${routeNamePrefix}.create`,
        component: () =>
          lazyLoadView(
            import(/* webpackChunkName: "users" */ './views/create')
          ),
        meta: {},
      },
      {
        path: ':id',
        name: `${routeNamePrefix}.edit`,
        component: () =>
          lazyLoadView(import(/* webpackChunkName: "users" */ './views/edit')),
        meta: {},
      },
    ],
  },
]
